import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { WithdrawJourney, WithdrawPraxisProvider } from 'src/domains/players/webview/components/WithdrawAndDeposit';
import { WithdrawPaysafeJourney } from 'src/domains/players/webview/components/WithdrawAndDeposit/withdrawProcedure/withdrawPaysafe/WithdrawPaysafeJourney';
import { WithdrawWorldpayJourney } from 'src/domains/players/webview/components/WithdrawAndDeposit/withdrawProcedure/withdrawWorldpay/WithdrawWorldpayJourney';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const WithdrawTab = observer('WithdrawProcedure', () => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const { paymentProviders } = configState;

    switch (paymentProviders.debitCard.type) {
        case 'realex':
        case null:
            return <WithdrawJourney />;
        case 'praxis':
            return <WithdrawPraxisProvider />;
        case 'paysafe':
            return <WithdrawPaysafeJourney />;
        case 'worldpay':
            return <WithdrawWorldpayJourney />;
    }
});
